export const QUESTION_DEFINITIONS = [
    { id: 1, category: 'storyEssence', valA: 'Story', valB: 'Essence' },
    { id: 2, category: 'storyEssence', valA: 'Story', valB: 'Essence' },
    { id: 3, category: 'storyEssence', valA: 'Story', valB: 'Essence' },
    { id: 4, category: 'individualUniversal', valA: 'Individual', valB: 'Universal' },
    { id: 5, category: 'individualUniversal', valA: 'Individual', valB: 'Universal' },
    { id: 6, category: 'individualUniversal', valA: 'Individual', valB: 'Universal' },
    { id: 7, category: 'exploreSelect', valA: 'Explore', valB: 'Select' },
    { id: 8, category: 'exploreSelect', valA: 'Explore', valB: 'Select' },
    { id: 9, category: 'exploreSelect', valA: 'Explore', valB: 'Select' },
    { id: 10, category: 'dialogueIntrospection', valA: 'Dialogue', valB: 'Introspection' },
    { id: 11, category: 'dialogueIntrospection', valA: 'Dialogue', valB: 'Introspection' },
    { id: 12, category: 'dialogueIntrospection', valA: 'Dialogue', valB: 'Introspection' },
];

export const AXES = {
    storyEssence: ['Story', 'Essence'],
    individualUniversal: ['Individual', 'Universal'],
    exploreSelect: ['Explore', 'Select'],
    dialogueIntrospection: ['Dialogue', 'Introspection']
};

export const TYPE_IMAGE_SLUGS = {
    'Story-Individual-Explore-Dialogue': 'storyteller',
    'Story-Individual-Explore-Introspection': 'storyteller',
    'Story-Individual-Select-Dialogue': 'romantic',
    'Story-Individual-Select-Introspection': 'romantic',
    'Story-Universal-Explore-Dialogue': 'craftsman',
    'Story-Universal-Explore-Introspection': 'craftsman',
    'Story-Universal-Select-Dialogue': 'timeless',
    'Story-Universal-Select-Introspection': 'timeless',
    'Essence-Individual-Explore-Dialogue': 'creator',
    'Essence-Individual-Explore-Introspection': 'creator',
    'Essence-Individual-Select-Dialogue': 'designer',
    'Essence-Individual-Select-Introspection': 'designer',
    'Essence-Universal-Explore-Dialogue': 'concierge',
    'Essence-Universal-Explore-Introspection': 'concierge',
    'Essence-Universal-Select-Dialogue': 'researcher',
    'Essence-Universal-Select-Introspection': 'researcher'
};

export const TYPE_RESULT_RING_IDS = {
    'Story-Individual-Explore-Dialogue': [86, 177, 56],
    'Story-Individual-Explore-Introspection': [86, 177, 56],
    'Story-Individual-Select-Dialogue': [177, 1, 58],
    'Story-Individual-Select-Introspection': [177, 1, 58],
    'Story-Universal-Explore-Dialogue': [10, 106, 244],
    'Story-Universal-Explore-Introspection': [10, 106, 244],
    'Story-Universal-Select-Dialogue': [178, 106, 63],
    'Story-Universal-Select-Introspection': [178, 106, 63],
    'Essence-Individual-Explore-Dialogue': [3, 1, 17],
    'Essence-Individual-Explore-Introspection': [3, 1, 17],
    'Essence-Individual-Select-Dialogue': [166, 1, 246],
    'Essence-Individual-Select-Introspection': [166, 1, 246],
    'Essence-Universal-Explore-Dialogue': [178, 166, 63],
    'Essence-Universal-Explore-Introspection': [178, 166, 63],
    'Essence-Universal-Select-Dialogue': [178, 106, 242],
    'Essence-Universal-Select-Introspection': [178, 106, 242]
};
